import useScrollLock from '@hooks/useBodyScrollLock';
import { ReactComponent as SvgChevronDown } from '@img/icons/chevron-down.svg';
import { ReactComponent as SvgClose } from '@img/icons/cross-icon.svg';
import React from 'react';
import S from './FiltersMobile.styles';
import FilterList from './List/FilterList';
const FiltersMobile = ({ checkboxFilters = [], categoryValues, filterValue, filters, sortByOptions, sortByValue, topicValues, onCheckBoxChange, onFilterChange, onSortChange, visible, setVisible, }) => {
    const ref = React.useRef(null);
    const [activeId, setActiveId] = React.useState('');
    useScrollLock(ref.current, visible);
    function clearFilters() {
        filters.map((filter) => {
            onFilterChange(filter.key, '');
        });
        onCheckBoxChange &&
            checkboxFilters.map((options) => {
                options && onCheckBoxChange(options.key, ['']);
            });
    }
    return (React.createElement(S.Container, { "aria-active": visible },
        React.createElement(S.Open, { onClick: (event) => {
                event.preventDefault();
                setVisible && setVisible(true);
            } },
            React.createElement("span", null, "Filters"),
            React.createElement(SvgChevronDown, null)),
        React.createElement(S.Overlay, { ref: ref },
            React.createElement(S.Close, { onClick: (event) => {
                    event.preventDefault();
                    setActiveId('');
                    setVisible && setVisible(false);
                } },
                React.createElement(SvgClose, null),
                React.createElement("span", null, "Close")),
            renderTopLevelList()),
        React.createElement(S.Background, { onClick: (event) => {
                event.preventDefault();
                setActiveId('');
                setVisible && setVisible(false);
            } })));
    function renderTopLevelList() {
        return (React.createElement(FilterList, { activeId: activeId, items: filters
                .filter((f) => !!f.options?.length)
                .map((filter) => ({
                id: filter.key,
                options: filter.options,
                selected: filter.key === filterValue[filter.key],
                showArrow: true,
                text: filter.title,
                value: filter.key,
            })), multi: checkboxFilters
                .filter((f) => (f ? !!f.options?.length : ''))
                .map((filter) => ({
                id: filter ? filter.key : '',
                options: filter ? filter.options : [],
                selected: false,
                showArrow: true,
                text: filter ? filter.title : '',
                value: filter ? filter.key : '',
            })), categoryValues: categoryValues, sortByOptions: sortByOptions, sortByValue: sortByValue, topicValues: topicValues, filterValue: filterValue, onFilterChange: onFilterChange, onSortChange: onSortChange, setVisible: setVisible, title: "Filters", onApply: () => {
                setActiveId('');
                setVisible && setVisible(false);
            }, onClear: () => {
                clearFilters();
            }, onSelect: (id) => {
                setActiveId(id);
            } }));
    }
};
export default FiltersMobile;
